import { Image, Modal, Typography } from "antd"
import React, { useState } from "react"

const { Link } = Typography

export default function TechnicalPageModal({ data }) {
  const [isModalOpen, setIsModalOpen] = useState(false)

  if (!data) return null

  return (
    <>
      <Link onClick={() => setIsModalOpen(true)}>View</Link>
      <Modal open={isModalOpen} onCancel={() => setIsModalOpen(false)} footer={null} centered>
        <Image src={data} alt="Technical Page" style={{ width: "100%" }} />
      </Modal>
    </>
  )
}
